<template>
  <div style="position:relative; padding: 10px 30px">
    <div>
      Use these keys to make API requests to Weborion services.
      <br>
      For your protection, you should never share your secret keys with anyone. As a best practice, we recommend
      frequent key rotation.
    </div>
    <div style="padding: 0 0 50px">
      <a-form :form="form" @submit="handleForm" class="token-form">
        <p class="token-label">
          Token Name:
        </p>
        <a-form-item>
          <a-input
                  v-decorator="[
              'Token Name',
              { rules: [{ required: true, message: 'Please input a Token Name' }] },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" class="password-button">
            <span v-if="loggedInUserDetail.username && impersonatedUserDetail.username && loggedInUserDetail.username != impersonatedUserDetail.username">Create for {{impersonatedUserDetail.username}}</span>
            <span v-else>Create</span>
            <div style="padding-left: 5px" v-if="this.createLoading">
              <a-icon type="sync" spin/>
            </div>
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="this.tableLoading">
      <Spinner/>
    </div>
    <div v-else>
      <PaginationTable style="overflow: auto" :columns="APITableColumn" :data-source="dataTable" :pagination="pagin">
        <template slot="status" slot-scope="{ record }">
          <a-tag :color="record.status === 'Inactive' ? 'volcano' : 'green'">
            {{ record.status }}
          </a-tag>
        </template>
        <template slot="actions" slot-scope="{ record }">
          <a @click="makeInactive(record)">Make {{record.status === 'Inactive' ? 'active':'inactive'}}</a>
          <a-divider type="vertical"/>
          <a @click="deleteKey(record)">Delete</a>
        </template>
        <template slot="created" slot-scope="{ record }">
          <span v-if="record.created">{{ record.created | dateString }} {{ record.created | timeString }}</span>
        </template>
        <template slot="lastUsed" slot-scope="{ record }">
          <span v-if="record.lastUsed">{{ record.lastUsed | dateString }} {{ record.lastUsed | timeString }}</span>
          <span v-else>Not used yet</span>
        </template>
      </PaginationTable>
      <div style="padding: 10px">
        <PaginationBar :total="pagin.total" @change="paginChange"/>
      </div>
    </div>

    <a-modal
            title="Create API Token"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @cancel="handleCancel"
            width="50%"
    >
      <template slot="footer">
        <a-button key="back" type='primary' @click="handleCancel">
          Close
        </a-button>
      </template>
      <div class="a-body p-20-px flex-grow-1">
        <div class="success-container">
          <a-icon type="check-circle" class="success-icon"/>
          <p class="success-message">
            Your new API token is now available.
          </p>
        </div>
        <p class="modal-message"> This is the only time that the secret access key can be viewed. </p>
        <p style="font-size: 15px"> You cannot recover it later. However, you can create new API tokens at any
          time. </p>
        <div class="key-container">
          <p class="key-text" style="text-align:right; font-weight:bold;">
            Token Name:
          </p>
          <p class="key-text">
            {{this.newTokenName}}
          </p>
          <p class="key-text" style="text-align:right; font-weight:bold;">
            Secret Key:
          </p>
          <p v-if="showKey" class="key-text">
            {{this.secretKey}}
            <br>
            <a class="key-text" @click="toggleShowKey()">
              Hide secret access key
            </a>
          </p>
          <p v-else class="key-text">
            <a class="key-text" @click="toggleShowKey()">
              Show secret access key
            </a>
          </p>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import AccountService from '../services/account.service';
  import { APITableColumn } from '../APITable/APITableColumn';

  export default {
    name: 'APIKey',
    data() {
      return{
        form: this.$form.createForm(this, { name: 'APIform' }),
        dataTable: [],
        APITableColumn,
        newTokenName: null,
        secretKey: null,
        visible: false,
        confirmLoading: false,
        showKey: false,
        createLoading: false,
        tableLoading: true,
        loggedInUserDetail: {},
        impersonatedUserDetail: {},
        pagin: {
          current: 1,
          pageSize: 5,
          total: 0
        },          
      }
    },
    mounted() {
      this.fetchList();
      this.initData();
    },
    methods: {
      async initData() {
        this.loggedInUserDetail = await AccountService.getUser();
        this.impersonatedUserDetail = await AccountService.getUserInRole();
      },
      async fetchList() {
        try {
          const responseData = await AccountService.fetchApiKeyList();
          this.dataTable = (responseData || []).map((item, index) => ({
            index: index + 1,
            tokenName: item.token_name,
            status: item.status,
            created: item.created_at,
            lastUsed: item.last_used_at
          }));
          this.pagin.total = responseData.length || 0;
        } catch (error) {
          this.$showErrorMessage('HTTP error received from web server.!');
          console.log(error)
        } finally {
          this.tableLoading = false;
        }
      },
      paginChange(pagin) {
        let itemCount = pagin.total;
        if (itemCount < 1) {
          itemCount = 1;
        }
        if(pagin.current > Math.ceil((itemCount*1.0)/pagin.pageSize)){
          let repage = {
            current: 1,
            pageSize: pagin.pageSize,
            total: pagin.total
          }
          this.paginChange(repage)
        }
        else{
          this.pagin = { ...pagin };
        }
      },
      
      handleCancel(e) {
        this.fetchList();           
        this.visible = false;
        this.showKey = false;
      },

      handleForm(e) {
        e.preventDefault();
        this.form.validateFields(async (err, values) => {
          if (!err) {
            try{
            this.createLoading = true; 
            const ApiKey = await AccountService.createApiKey(values["Token Name"]);
            this.newTokenName = ApiKey['token_name']
            this.secretKey = ApiKey['secret_key']
            this.visible = true;           
            } catch(error){
              const messages = error && error.messages && error.messages.length
                              ? error.messages
                              : ["Failed to create API token"];
              this.$showMultiErrorMessage(messages);
            } finally{
              this.createLoading = false;
            }
          }
        });
      },

      toggleShowKey(){
        this.showKey = (this.showKey === false) ? true : false
      },

      makeInactive(record){
        this.$confirm({
          title: 'Are you sure to deactivate this API token? ',
          content: (h) => <div> {record.tokenName} </div>,
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            const new_status = (record.status === "Active") ? "Inactive" : "Active";
            await AccountService.updateApiKeyStatus(record.tokenName, {"status": new_status});
            await this.fetchList();
            this.$showSuccessMessage("API token deactivated successfully")
          },
        });
      },      

      deleteKey(record){
        this.$confirm({
          title: 'Are you sure to delete this API token? ',
          content: (h) => <div> {record.tokenName} </div>,
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            if(this.pagin.total - (this.pagin.current-1)*this.pagin.pageSize == 1){
              await AccountService.deleteApiKey(record.tokenName)
              this.tableLoading = true;
              this.dataTable = null;
              await this.fetchList();
              let repage = {
                current: 1,
                pageSize: this.pagin.pageSize,
                total: this.pagin.total
              }
              this.paginChange(repage);
              this.tableLoading = false;
              this.$showSuccessMessage("API token deleted successfully");
            } else {
              await AccountService.deleteApiKey(record.tokenName);
              await this.fetchList();
              this.$showSuccessMessage("API token deleted successfully");
            }         
          },
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .password-button{
    display:flex;
    height: 40px;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    line-height: 21px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 14px;
    text-align: center;
    -webkit-appearance: none;
    white-space: nowrap;
    -moz-appearance: none;
    appearance: none;
  }
  .token-label{
    margin: 6px 0 0;
    font-weight: bold
  }
  // label | input | Create, on one row.
  .token-form{
    display:grid;
    max-width: 620px;
    grid-template-columns: 100px minmax(0, 1fr) auto;
    column-gap: 12px;
    align-items: start;
    padding: 10px 0;
    // Ant's per-item bottom margin would double up with the link's own spacing.
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .success-container{
    color: #52c41a;
    background: #f6ffed;
    border: 1px;
    border-style: solid;
    border-radius: 5px;
    border-color: #b7eb8f;
    display: grid;
    grid-template-columns: 40px 1fr;
    padding: 10px;
  }
  .success-tag{
    display: grid;
    grid-template-columns: 40px 1fr;
    padding: 10px;
  }
  .success-icon{
    margin: auto 10px;
    font-size: 20px;
  }
  .success-message{
    margin: 10px;
    font-size: 20px;
  }
  .modal-message{
    margin: 10px 0 0 0;
    color:orange ;
    font-weight:bold;
    font-size: 15px;
  }
  .key-container{
    display: grid;
    grid-template-columns: 125px 1fr;
    grid-gap: 5px;
    padding: 10px;
    background-color:rgb(240, 240, 240);
    font-size: 15px;
    margin: 0 auto;
  }
  .key-text{
    word-break: break-all;
    font-size: 15px; 
    margin: 0;
  }
</style>
